import axios from 'axios'


export interface TourStep {
    title: string;
    text: string;
    image: string;
    index: number;
}

const fetchPresignedUrl = async (fileKey: string) => {
    try {
        if (!fileKey) return null;
        const response = await axios.get("/batchfile/fetch-file-url", {
            params: { fileKey },
        });
        if (response.status === 200) {
            return response.data.presignedUrl;
        }
    } catch (error) {
        console.error("Error fetching presigned URL for image:", error);
    }
    return null;
};

export const getTourSteps = async (tourId: string) => {
  
        if (tourId === 'mars') {
        const marsSteps = [
            {
                index: 1,
                title: 'Navigate to MARS Section',
                text: 'Go to the MARS section from the sidebar and click on "Individual Medication".',
                image: 'how-to-documents/Mars1.png',
            },
            {
                index: 2,
                title: 'Click on Add Medications',
                text: 'Click on the "ADD MEDICATIONS" button to open the form for adding new medication.',
                image: 'how-to-documents/Mars2.png',
            },
            {
                index: 3,
                title: 'Fill the Medication Form',
                text: 'Enter details like client name, medication name, dosage info, number of meds, and timings, then click SAVE.',
                image: 'how-to-documents/Mars3.png',
            },
            {
                index: 4,
                title: 'Click on Add Medication Entry',
                text: 'After adding the medication, click on "ADD MEDICATION ENTRY" to record the administration.',
                image: 'how-to-documents/Mars4.png',
            },
            {
                index: 5,
                title: 'Select Client and Date',
                text: 'Select the client and date for whom you want to add the medication entry, then click NEXT.',
                image: 'how-to-documents/Mars6.png',
            },
            {
                index: 6,
                title: 'Fill the Medication Entry Form',
                text: 'Enter the number of meds given, dosage, time, and any comments. Click SAVE to record it.',
                image: 'how-to-documents/Mars7.png',
            },
            {
                index: 7,
                title: 'Generate Medication PDF',
                text: 'Click on "GENERATE PDF" to export the medication list for the client.',
                image: 'how-to-documents/Mars8.png',
            },
            {
                index: 8,
                title: 'Select Client and Month-Year for PDF',
                text: 'Choose the client, month, and year to generate the correct PDF. Then submit the form.',
                image: 'how-to-documents/Mars9.png',
            }
            ];

        const stepsWithUrls = await Promise.all(marsSteps.map(async (step) => {
            const presignedUrl = await fetchPresignedUrl(step.image);
            return {
            ...step,
            image: presignedUrl || step.image
            };
        }));
        return {
            title: 'How to (MARS)',
            steps: stepsWithUrls
        };
        }

        if (tourId === 'importCaregivers') {
        const importSteps = [
            { index: 1, title: 'Navigate to Import Caregivers Section', text: 'Find the import Caregivers section in the admin menu.', image: 'how-to-documents/importCaregiver1.png' },
            { index: 2, title: 'Download caregiver Excel template', text: 'Click Download Template.', image: 'how-to-documents/importCaregiver2.png' },
            { index: 3, title: 'Fill in caregiver details', text: 'Fill in all required fields in Excel.', image: 'how-to-documents/importCaregiver3.png' },
            { index: 4, title: 'Upload the filled template', text: 'Click Upload and select the completed file.', image: 'how-to-documents/importCaregiver2.png' },
            { index: 5, title: 'Review and confirm import status', text: 'Check the status message for errors/success.', image: 'how-to-documents/importCaregiver4.png' }
        ];
        const stepsWithUrls = await Promise.all(importSteps.map(async (step) => {
            const presignedUrl = await fetchPresignedUrl(step.image);
            return {
            ...step,
            image: presignedUrl || step.image
            };
        }));
        return {
            title: 'How to (Import Caregivers)',
            steps: stepsWithUrls
        };
        }

        if (tourId === 'clientAttendance') {
        const attendanceSteps = [
        {
            index: 1,
            title: 'Open Professional Claim',
            text: 'Go to the Billing section in the sidebar and click on "Professional Claim".',
            image: 'how-to-documents/Attendance1.png'
        },
        {
            index: 2,
            title: 'Click Add New',
            text: 'Click on the "Add New" button to create a new service authorization.',
            image: 'how-to-documents/Attendance2.png'
        },
        {
            index: 3,
            title: 'Select Client',
            text: 'Choose the client for whom you want to create the service authorization.',
            image: 'how-to-documents/Attendance3.png'
        },
        {
            index: 4,
            title: 'Fill Service Authorization Form',
            text: 'Enter the required information in the form like dates, service code, and unit rate.',
            image: 'how-to-documents/Attendance4.png'
        },
        {
            index: 5,
            title: 'Open Attendance',
            text: 'Now go to the Billing section again and click on "Attendance".',
            image: 'how-to-documents/Attendance5.png'
        },
        {
            index: 6,
            title: 'Search Attendance',
            text: 'Select the required filters to find attendance records. Leave the client field empty to view all.',
            image: 'how-to-documents/Attendance6.png'
        },
        {
            index: 7,
            title: 'Fill All Clients’ Attendance',
            text: 'Mark attendance for all listed clients for each date shown.',
            image: 'how-to-documents/Attendance7.png'
        },
        {
            index: 8,
            title: 'Select Specific Client',
            text: 'You can also search and select a specific client to focus only on their attendance.',
            image: 'how-to-documents/Attendance8.png'
        },
        {
            index: 9,
            title: 'Fill Specific Client Attendance',
            text: 'Now fill in the attendance details for the selected client only.',
            image: 'how-to-documents/Attendance9.png'
        },
        {
            index: 10,
            title: 'Generate PDF',
            text: 'Click the "Generate PDF" button to download the attendance record.',
            image: 'how-to-documents/Attendance10.png'
        }
];

        const stepsWithUrls = await Promise.all(attendanceSteps.map(async (step) => {
            const presignedUrl = await fetchPresignedUrl(step.image);
            return {
            ...step,
            image: presignedUrl || step.image
            };
        }));
        return {
            title: 'How to (Client Attendance and Service Auth)',
            steps: stepsWithUrls
        };
        }

        if (tourId === 'behavior') {
        const behaviorSteps = [
        {
            index: 1,
            title: 'Go to Client Behavior Section',
            text: 'Navigate to the Client Behavior section in the sidebar and click on Client Behavior.',
            image: 'how-to-documents/Behaviour1.png', 
        },
        {
            index: 2,
            title: 'Add Client Behavior',
            text: 'Click the "Add Client Behavior" button.',
            image: 'how-to-documents/Behaviour2.png', 
        },
        {
            index:3,
            title:"Fill in the Add Client's Behavior form",
            text:"Select a client and then choose the target behavior and its replacement. Click Save to submit.",
            image:'how-to-documents/Behaviour8.png',
        },
        {
            index: 4,
            title: 'Add Behavior Entry',
            text: 'Click on "Add Behavior Entry"',
            image: 'how-to-documents/Behaviour2.png', 
        },
        {
             index: 3,
            title: 'Fill in the Add Behavior Entry form',
            text: 'Select the same client, pick the relevant date, and fill in the behavior details (ratings, descriptions). Then save the entry.',
            image: 'how-to-documents/Behaviour4.png', 
        },
        {
            index: 4,
            title: 'View Behavior Insights',
            text: 'Go to the Export Insights tab under Behavior. Select the client and time range to view visual insights in chart form.',
            image: 'how-to-documents/Behaviour9.png', 
        },
        {
            index: 5,
            title: 'Export PDF Report',
            text: 'Click the Export button on the insights page to download the behavior report as a PDF.',
            image: 'how-to-documents/Behaviour10.png', 
        },
        ];
        const stepsWithUrls = await Promise.all(behaviorSteps.map(async (step) => {
            const presignedUrl = await fetchPresignedUrl(step.image);
            return {
            ...step,
            image: presignedUrl || step.image
            };
        }));
        return {
            title: 'How to (Behavior Section)',
            steps: stepsWithUrls
        };
        }


      const locationSettings = [
    {
        title: 'Click the Icon',
        text: 'Click the  icon at the top left of the address bar, next to the site URL.',
        image: 'how-to-documents/location_1.png',
        index: 1
    },
    {
        title: 'Allow Location Access',
        text: 'When prompted, choose "Allow while visiting the site", "Allow this time", or "Never allow" based on your preference.',
        image: 'how-to-documents/location_2.png',
        index: 2
    },
    {
        title: 'Check Location Permission',
        text: 'You can manually toggle the location access by clicking the icon again and turning the location switch on or off.',
        image: 'how-to-documents/location_3.png',
        index: 3
    },
    {
        title: 'Reload to Apply Changes',
        text: 'Click the "Reload" button when prompted to apply your updated location settings.',
        image: 'how-to-documents/location_4.png',
        index: 4
    },
    {
        title: 'Location Access Enabled',
        text: 'After reloading, your selected location setting will be active for this site. You can change it again anytime.',
        image: 'how-to-documents/location_5.png',
        index: 5
    }
];

        if (tourId === 'locationSettings') {
        const stepsWithUrls = await Promise.all(locationSettings.map(async (step) => {
            const presignedUrl = await fetchPresignedUrl(step.image);
            return {
                ...step,
                image: presignedUrl || step.image
            };
        }));

        return {
         title: 'How to Enable Location Settings',
         steps: stepsWithUrls
        };
    }

    const clientCreationSteps = [
        { fileKey: `how-to-documents/client_sidebar.png`, index: 1, title: 'Navigate to Sidebar', text: 'Click on the Care section in Admin section in the sidebar menu to access client.' },
        { fileKey: `how-to-documents/client_modal.png`, index: 2, title: 'Client Modal', text: 'A Popup will appear. Look for the "ADD NEW" button in the bottom right corner of the popup and click it to proceed.' },
        { fileKey: `how-to-documents/client_new_form.png`, index: 3, title: 'Client Intake Form', text: 'Fill in the Client Intake Form (CIF) with all required information: upload a photo, select gender, enter name, birth date, phone number, email, social security number, medicaid number (if applicable), and complete the residential address section.' },
        { fileKey: `how-to-documents/client_form_filled.png`, index: 4, title: 'Review and Save', text: 'Review all entered information carefully. Once verified, click the "Save" button at the bottom right of the form. If you need to start over, use the "Cancel" button.' },
        { fileKey: `how-to-documents/client_selection_modal.png`, index: 5, title: 'Find Your Client', text: 'After successful creation, you can find your new client by typing their name in the "Search for client" field at the top of the client popup.' }
    ];
    if (tourId === 'careProviders') {
        const careProviderSteps = [
            {
                index: 1,
                title: 'Open Caregiver General Section',
                text: 'In the sidebar, click on the "Caregiver/Nurses/Therapists" section and then select "General" to view the caregiver list.',
                image: 'how-to-documents/Caregiver_12.png',
            },
            {
                index: 2,
                title: 'Click Add Caregiver',
                text: 'Click the "Add Caregiver" button at the top right to start creating a new caregiver.',
                image: 'how-to-documents/Caregiver2.png',
            },
            {
                index: 3,
                title: 'Fill Caregiver Details',
                text: 'Enter the caregivers first name, last name, phone, email, and assign roles with wage details. Then click "Save".',
                image: 'how-to-documents/Caregiver3.png',
            }
        ];

        const stepsWithUrls = await Promise.all(careProviderSteps.map(async (step) => {
            const presignedUrl = await fetchPresignedUrl(step.image);
            return {
                ...step,
                image: presignedUrl || step.image
            };
        }));

        return {
            title: 'How to (Care Providers)',
            steps: stepsWithUrls
        };
    }

    if (tourId === 'caregiverSchedules') {
        const scheduleSteps = [
            {
                index: 1,
                title: 'Go to Schedules Section',
                text: 'Navigate back to the "Caregiver/Nurses/Therapists" section in the sidebar and click on "Schedules" to manage scheduling.',
                image: 'how-to-documents/Caregiver_12.png',
            },
            {
                index: 2,
                title: 'Add a Schedule',
                text: 'Click on the "+" icon next to the caregivers name to add a new schedule.',
                image: 'how-to-documents/Caregiver5.png',
            },
            {
                index: 3,
                title: 'Fill Schedule Form',
                text: 'Choose time, role, preferred/unavailable status, and select additional days if needed. Click "Save" to apply the schedule.',
                image: 'how-to-documents/Caregiver6.png',
            },
            {
                index: 4,
                title: 'Add a New Schedule',
                text: 'Select the start and end time, location, role (e.g., Caregiver), and the applicable days. Then click "Save".',
                image: 'how-to-documents/Caregiver_7.png',
            },
            {
                index: 5,
                title: 'Publish the Schedule',
                text: 'Click the "Publish Schedule" button to activate the newly created schedule. You will see confirmation that its published.',
                image: 'how-to-documents/Caregiver__8.png',
            },
            {
                index: 6,
                title: 'Clock In for Shift',
                text: 'Click the clock icon, select your role, and press "Clock In" to begin your shift.',
                image: 'how-to-documents/Caregiver_9.png',
            },
            {
                index: 7,
                title: 'Start a Break',
                text: 'During your shift, click "Start Break" to begin your break. Time tracking will pause accordingly.',
                image: 'how-to-documents/Caregiver_10.png',
            },
            {
                index: 8,
                title: 'End a Break',
                text: 'Once ready to resume work, click "End Break" to continue your shift.',
                image: 'how-to-documents/Caregiver_11.png',
            },
            {
                index: 9,
                title: 'Clock Out',
                text: 'At the end of your shift, click "Clock Out" to stop time tracking.',
                image: 'how-to-documents/Caregiver_11.png',
            }
        ];

        const stepsWithUrls = await Promise.all(scheduleSteps.map(async (step) => {
            const presignedUrl = await fetchPresignedUrl(step.image);
            return {
                ...step,
                image: presignedUrl || step.image
            };
        }));

        return {
            title: 'How to (Caregiver Schedules)',
            steps: stepsWithUrls
        };
    }

    if (tourId === 'caregiverTimesheets') {
        const timesheetSteps = [
            {
                index: 1,
                title: 'View Timesheets',
                text: 'Navigate to the sidebar under "Caregiver/Nurses/Therapists" → "Timesheets" → "Company Timesheets" to review logs.',
                image: 'how-to-documents/Caregiver_12.png',
            },
            {
                index: 2,
                title: 'Access Company Timesheets',
                text: 'Once inside the "Timesheets" section, the "Company Timesheets" tab will be selected by default. Here you can review the caregiver\'s logged shifts and related details.',
                image: 'how-to-documents/Caregiver_13.png',
            },
            {
                index: 3,
                title: 'Review Work Summary',
                text: 'Here, you can view total hours worked, break times, and the total calculated pay for each shift.',
                image: 'how-to-documents/Caregiver_14.png',
            }
        ];

        const stepsWithUrls = await Promise.all(timesheetSteps.map(async (step) => {
            const presignedUrl = await fetchPresignedUrl(step.image);
            return {
                ...step,
                image: presignedUrl || step.image
            };
        }));

        return {
            title: 'How to (Caregiver Timesheets)',
            steps: stepsWithUrls
        };
    }
    const uploadClientsSteps = [
        { fileKey: `how-to-documents/client-upload-step_1.png`, index: 1, title: 'Navigate to Sidebar', text: 'Click on the <strong>Import Clients</strong> section in <strong>User Management section</strong> in the sidebar menu to access upload clients.' },
        { fileKey: `how-to-documents/client-upload-step_2.png`, index: 2, title: 'Download Template', text: 'Click on the "Download" button to get the Excel template. The downloaded template will contain column headers for all required client information.' },
        { fileKey: `how-to-documents/client-upload-step_3.png`, index: 3, title: 'Empty Template Structure', text: 'The template includes columns for First Name, Last Name, Email, Phone, Address, and other required fields. Each column header specifies the expected format of data.' },
        { fileKey: `how-to-documents/client-upload-step_4.png`, index: 4, title: 'Fill Template Example', text: 'Here\'s an example of correctly filled client data. Notice how each field follows the required format: phone numbers include country code, emails are valid, and dates follow MM-DD-YYYY format. <br/><br/><strong>Note: Either Social Security Number, Medicaid Number, or Private Pay must be provided.</strong>' },
        { fileKey: `how-to-documents/client-upload-step_2.png`, index: 5, title: 'Upload Completed File', text: 'Return to the application and click the "Upload" button. Select your completed Excel file to begin the upload process.' },
        { fileKey: `how-to-documents/client-upload-step_6.png`, index: 6, title: 'Verify Upload Status', text: 'Check the notification in the top right corner. A success message means all clients were added. If there are errors, the message will indicate which rows have issues. Fix those entries and try uploading again.' }
    ];

    if (tourId === 'clientCreation') {
        const stepsWithUrls = await Promise.all(clientCreationSteps.map(async (step) => {
            const presignedUrl = await fetchPresignedUrl(step.fileKey);
            return {
                ...step,
                image: presignedUrl || step.fileKey
            };
        }));

        return {
            title: 'How to Create Client',
            steps: stepsWithUrls
        };
    }

    if (tourId === 'uploadClients') {
        const stepsWithUrls = await Promise.all(uploadClientsSteps.map(async (step) => {
            const presignedUrl = await fetchPresignedUrl(step.fileKey);
            return {
                ...step,
                image: presignedUrl || step.fileKey
            };
        }));

        return {
            title: 'How to Upload Clients through Excel',
            steps: stepsWithUrls
        };
    }

    throw new Error('Invalid tour ID');
}; 
